export default __webpack_public_path__ + "static/media/login-bg.869ccd1f.png";